import ImageCompare from "image-compare-viewer";
const $element = document.querySelector<HTMLDivElement>("[data-image-compare-container]");
if($element) {
    const viewer = new ImageCompare($element).mount();

}